import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
} from "@mui/material";

function TableDataCode({
  columnWidth,
  heading,
  columnValue,
  title,
  topHeading,
  topheader,
  formValues,
  setErrors,
  errorsindex,
  setFormValues,
  setRowIndex,
  errors,
  disabled,
}) {
  const [columnArray, setColumnArray] = useState([]);

  useEffect(() => {
    const columnLength = columnWidth.split(" ");
    setColumnArray(columnLength);
  }, [columnWidth]);

  const handleChangeRadio = ({ target: { name, value } }) => {
    setFormValues((prev) => {
      const keys = name.split("."); // Assuming `name` is a dot-separated string
      const updatedForm = { ...prev };

      let current = updatedForm;
      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          current[key] = value; // Update the specific field
        } else {
          current[key] = { ...current[key] };
          current = current[key];
        }
      });

      return updatedForm;
    });
  };

  useEffect(() => {
    let newErrors = {};

    columnValue.forEach((item, rowIndex) => {
      if (item.value) {
        heading.slice(1).forEach((headings) => {
          const name = `${headings.key}.${item.key}`;
          newErrors[name] = {
            rowIndex,
            message: "", // Initialize with empty error message
          };
        });
      }
    });

    // Preserve previous errors instead of overriding them

    if (setRowIndex) {
      setRowIndex((prevIndex) => ({
        ...prevIndex,
        ...newErrors,
      }));
    }
  }, []);

  const handleChange = (e, index) => {
    const { name, value } = e.target;

    if (!/^\d*$/.test(value)) return; // Allow only numeric values

    setFormValues((prevState) => {
      if (!prevState) return {};
      const keys = name.split(".");
      const updatedData = structuredClone(prevState);

      let currentLevel = updatedData;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!currentLevel[keys[i]]) {
          currentLevel[keys[i]] = {};
        }
        currentLevel = currentLevel[keys[i]];
      }
      // Update value
      currentLevel[keys[keys.length - 1]] = value ? Number(value) : "";

      // Ensure `total`, `male`, and `female` exist before calculations
      const totalEmployees = currentLevel?.total || 0;

      let lastPreviousKeys = [];
      let tempData = updatedData;
      for (let i = 0; i < keys.length - 1; i++) {
        if (tempData?.[keys[i]]) {
          if (keys.length >= 5) {
            // If 4 or more keys, store the second key and last-to-previous key
            lastPreviousKeys.push(Object.keys(tempData[keys[i]]));
          }

          tempData = tempData[keys[i]]; // Move deeper
        } else {
          break;
        }
      }

      const totalMale =
        updatedData?.[keys[0]]?.[keys[1]]?.[keys[2]]?.totalEmployee?.male || 0;
      const totalFemale =
        updatedData?.[keys[0]]?.[keys[1]]?.[keys[2]]?.totalEmployee?.female ||
        0;
      const totalOverall = (totalMale + totalFemale) / 2;

      const employeeMale =
        updatedData?.[keys[0]]?.[keys[1]]?.[keys[2]]?.employee?.male || 0;
      const employeeFemale =
        updatedData?.[keys[0]]?.[keys[1]]?.[keys[2]]?.employee?.female || 0;
      const employeeOverall = (employeeMale + employeeFemale) / 2;

      // Calculate percentages
      if (
        updatedData[keys[0]] &&
        updatedData[keys[0]][keys[1]] &&
        updatedData[keys[0]][keys[1]][keys[2]]
      ) {
        updatedData[keys[0]][keys[1]][keys[2]].Percentage = {
          male:
            totalMale > 0 ? ((employeeMale / totalMale) * 100).toFixed(3) : "0",
          female:
            totalFemale > 0
              ? ((employeeFemale / totalFemale) * 100).toFixed(3)
              : "0",
          total:
            totalOverall > 0
              ? ((employeeOverall / totalOverall) * 100).toFixed(3)
              : "0",
        };
      }
      let newValue = keys[keys.length - 1] === "male" ? totalMale : totalFemale;
      let maxAllowedTotal =
        keys[keys.length - 1] === "male" ? employeeMale : employeeFemale;
      console.log(
        maxAllowedTotal,
        newValue,
        keys[keys.length - 1],
        "valuessssforChecking",
      );
      if (maxAllowedTotal > newValue) {
        return prevState;
      }

      const mainKey = keys.length > 3 ? `${keys[0]}.${keys[1]}` : keys[0];

      if (keys.length > 3) {
        const [firstKey, secondKey, thirdKey] = keys;
        if (
          updatedData[firstKey]?.[secondKey]?.[thirdKey] &&
          lastPreviousKeys[3].includes("total")
        ) {
          updatedData[firstKey][secondKey][thirdKey].total = calculateTotals(
            updatedData[firstKey][secondKey][thirdKey],
          );
        }
      } else {
        if (updatedData[mainKey] && lastPreviousKeys[0].includes("total")) {
          updatedData[mainKey] = calculateTotals(updatedData[mainKey]);
        }
      }

      return updatedData;
    });
  };

  const calculateTotals = (data) => {
    // let totals = { total: 0, male: 0, female: 0 };

    const traverse = (node) => {
      if (typeof node !== "object" || node === null) return;

      Object.entries(node).forEach(([key, value]) => {
        if (key === "Percentage") return;

        if (typeof value === "object" && value !== null) {
          if ("male" in value && "female" in value && "total" in value) {
            let male = Number(value.male) || 0;
            let female = Number(value.female) || 0;
            value.total = male + female;
          }

          traverse(value);
        }
      });
    };

    traverse(data);

    // return totals;
  };

  return (
    <Box sx={{ minWidth: 650 }}>
      <Typography
        variant="h6"
        sx={{
          textDecoration: "underline",
          textTransform: "Capitalize",
          fontWeight: "bold",
          margin: "15px 0",
        }}
      >
        {topheader}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", margin: "15px 0" }}
        gutterBottom
      >
        {topHeading}
      </Typography>
      <Typography
        sx={{ marginBottom: "20px", fontWeight: "bold", marginTop: "10px" }}
        variant="body1"
        gutterBottom
      >
        {title}
      </Typography>
      <TableContainer
        component={Paper}
        sx={{ maxWidth: "100%", borderRadius: "10px", overflow: "hidden" }}
      >
        <Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: columnWidth,
              background: " #1C486B",
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {heading.map((item) => {
              return (
                <Typography
                  sx={{
                    height: "100%",
                    // fontWeight: "bold",
                    padding: "8px 12px",
                    color: "#FFFFFF",
                    paddingY: "10px",
                    borderRight: "1px solid #DBDBDB ",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {item.title}
                </Typography>
              );
            })}
          </Box>

          {columnValue.map((item, rowIndex) => {
            if (item.value) {
              const isTotalRow = item.value.includes("Total"); // Check if the row is a Total row

              return (
                <Box
                  key={item._id}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: columnWidth,
                    borderBottom: "1px solid #ddd",
                    justifyContent: "center",
                  }}
                >
                  {/* Render Typography for the row */}
                  <Typography
                    sx={{
                      borderRight: "1px solid #DBDBDB",
                      fontSize: "15px",
                      padding: "10px",
                    }}
                  >
                    {item.value}
                  </Typography>
                  {heading.length > 0 &&
                    heading.slice(1).map((headings, index) => {
                      const name = `${headings.key}.${item.key}`;
                      // Split the name into parts using '.' as a delimiter
                      const matchResult = name.split(".");
                      // Ensure the split result is valid
                      if (matchResult.length < 3) {
                        // console.error(`Invalid name format: ${name}`);
                        return null; // Skip this iteration if the name format is invalid
                      }

                      const [mainKey, subKey, fieldKey, field1Key, field2Key] =
                        matchResult;

                      // const isPercentage = headings.title.includes("%");
                      const isPercentage =
                        headings.key !== "employeesCovered" &&
                        headings.key !== "workersCovered" &&
                        headings.title.includes("%");
                      // const isTotal = headings.title.includes("Total" !=="Total Employees");
                      const isTotal =
                        /Total(?! Employees || ?! No. of Employees)/.test(
                          headings.title,
                        );

                      return (
                        <>
                          {headings.type === "boolean" ? (
                            <RadioGroup
                              disabled={disabled}
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "0px",
                                padding: "0px 5px",
                              }}
                              // defaultValue="Yes" // Set the default selected value
                              value={
                                (mainKey === "retirementBenefits" &&
                                  formValues?.[mainKey]?.[subKey]?.[fieldKey]
                                    ?.deductedDeposited) ||
                                ""
                              }
                              name={name}
                              onChange={(e) =>
                                handleChangeRadio({
                                  target: {
                                    name,
                                    value: e.target.value,
                                  },
                                })
                              }
                            >
                              {["Yes", "No", "N/A"].map((item, index) => (
                                <FormControlLabel
                                  key={index}
                                  value={item}
                                  control={<Radio disabled={disabled} />}
                                  label={item}
                                />
                              ))}
                            </RadioGroup>
                          ) : (
                            <TextField
                              key={index} // Adding a key for mapping
                              variant="standard"
                              disabled={
                                isPercentage || isTotal || isTotalRow
                                  ? true
                                  : disabled
                              }
                              sx={{
                                backgroundColor:
                                  isPercentage || isTotal || isTotalRow
                                    ? "#EFEFEF"
                                    : "",
                                borderRight: "1px solid #DBDBDB",
                                padding: "8px 12px",
                                "& .MuiInputBase-root": {
                                  padding: 0, // Align with grid cells
                                },
                              }}
                              name={name}
                              type="text"
                              InputProps={{ disableUnderline: true }}
                              fullWidth
                              size="small"
                              value={
                                formValues?.[mainKey]?.[subKey]?.[fieldKey]?.[
                                  field1Key
                                ]?.[field2Key] ?? ""
                              }
                              placeholder={
                                isTotal
                                  ? "Total"
                                  : isPercentage
                                    ? "%"
                                    : "Enter Number"
                              }
                              onChange={
                                !isTotalRow
                                  ? (e) => handleChange(e, rowIndex)
                                  : undefined
                              }
                            />
                          )}
                        </>
                      );
                    })}
                </Box>
              );
            }
          })}
        </Box>
      </TableContainer>

      {Array.isArray(errors) && errors.length > 0
        ? Object.entries(
            errors?.reduce((acc, item) => {
              if (!acc[item.rowIndex]) {
                acc[item.rowIndex] = [];
              }
              acc[item.rowIndex].push(item.fieldName);
              return acc;
            }, {}),
          ).map(([rowIndex, fields], idx) => (
            <Typography
              variant="body2"
              color="error"
              key={`error-${rowIndex}-${idx}`}
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginTop: "0px",
              }}
            >
              Row {rowIndex} Missing fields: - {fields.join(", ")}
              {/* Row {rowIndex}: {fields.join(", ")} */}
            </Typography>
          ))
        : null}
    </Box>
  );
}

export default TableDataCode;
